import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../../../components/AppShell/styles";
import { Box } from "../../../../../../components/Layout";

export const Container = styled.div`
  .add-new-section {
    display: flex;
    align-items: center;
    cursor: pointer;
    > h6 {
      margin-left: 12px;
    }
  }
`;

export const SectionsBox = styled(Box)`
  /* Same vertical spacing as the creation steps above (Box's own is 2rem) */
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  /* Room for the fixed bar (96px): the list's last card stays the padding above away from it */
  margin-bottom: 6rem;

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  /* The help text opens the list, as the label of a block (same as "Selecione um template…") */
  .help {
    margin-bottom: 0.75rem;
  }

  .plus-notice {
    margin-bottom: 1.5rem;
  }
`;

/* Last row of the list: a dashed card to add a section (same as "Criar Keepo" in /sites) */
export const AddSectionCard = styled.button`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 66px;
  padding: 0.75rem 1rem;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-neutral-150);
  border: 2px dashed var(--color-neutral-base);
  border-radius: 1rem;
  transition:
    border-color 0.15s,
    color 0.15s;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: var(--color-neutral-dark);
    border-radius: 100%;
  }

  &:hover {
    color: var(--color-neutral-white);
    border-color: var(--color-neutral-light);
  }
`;

/* Same spacing between rows as the items lists (ItemsTable) */
export const CardItemWrapper = styled.div`
  position: relative;
  padding-top: 0.5rem;

  /* the row whose "⋯" menu is open goes over the rows below, or they'd cover the menu */
  &:has([role="menu"]) {
    z-index: 30;
  }
`;

export const ContinueButtonSection = styled.div`
  width: 50%;
`;
